var type = function type(operand) {
  return Object.prototype.toString.call(operand).slice(8, -1).toLowerCase();
};

export default type;